// Background for each partner resource card
export const gradientColors = [
  { start: '#0B0B0C', end: '#39271C' },
  { start: '#17161C', end: '#3A2E47' },
  { start: '#0F0F11', end: '#26282E' },
  { start: '#0B0B0C', end: '#39271C' },
  { start: '#17161C', end: '#3A2E47' },
  { start: '#0F0F11', end: '#26282E' },
];

export const EmojiFlagMap: Record<string, string> = {
  // Core
  'English': '🇺🇸',
  'Brazilian Portuguese': '🇧🇷',
  'Castilian Spanish': '🇪🇸',
  'French': '🇫🇷',
  'German': '🇩🇪',
  'Hindi': '🇮🇳',
  'Italian': '🇮🇹',
  'Japanese': '🇯🇵',
  'Korean': '🇰🇷',
  'Latin American Spanish': '🇲🇽',
  'Chinese': '🇨🇳',
  'Russian': '🇷🇺',
  'Arabic': '🇸🇦',
  'Dutch': '🇳🇱',

  // English variants
  'English (US)': '🇺🇸',
  'English (UK)': '🇬🇧',
  'English (Canada)': '🇨🇦',
  'English (Australia)': '🇦🇺',
  'English (India)': '🇮🇳',

  // Spanish variants
  'Spanish': '🇪🇸',
  'Spanish (Spain)': '🇪🇸',
  'Spanish (Mexico)': '🇲🇽',
  'Spanish (Argentina)': '🇦🇷',
  'Spanish (Colombia)': '🇨🇴',
  'Spanish (Chile)': '🇨🇱',
  'Spanish (Peru)': '🇵🇪',

  // Portuguese variants
  'Portuguese': '🇵🇹',
  'Portuguese (Portugal)': '🇵🇹',

  // Chinese variants
  'Simplified Chinese': '🇨🇳',
  'Traditional Chinese': '🇹🇼',
  'Chinese (Hong Kong)': '🇭🇰',

  // European languages
  'Swedish': '🇸🇪',
  'Norwegian': '🇳🇴',
  'Danish': '🇩🇰',
  'Finnish': '🇫🇮',
  'Polish': '🇵🇱',
  'Czech': '🇨🇿',
  'Hungarian': '🇭🇺',
  'Romanian': '🇷🇴',
  'Greek': '🇬🇷',
  'Turkish': '🇹🇷',
  'Ukrainian': '🇺🇦',

  // Asian languages
  'Bengali': '🇧🇩',
  'Urdu': '🇵🇰',
  'Tamil': '🇮🇳',
  'Telugu': '🇮🇳',
  'Vietnamese': '🇻🇳',
  'Thai': '🇹🇭',
  'Indonesian': '🇮🇩',
  'Malay': '🇲🇾',
  'Filipino': '🇵🇭',

  // Middle East/Africa
  'Hebrew': '🇮🇱',
  'Persian': '🇮🇷',
  'Swahili': '🇰🇪',
  'Afrikaans': '🇿🇦',

  // Additional
  'Catalan': '🇪🇸',
  'Slovak': '🇸🇰',
  'Bulgarian': '🇧🇬',
  'Croatian': '🇭🇷',
  'Serbian': '🇷🇸',
  'Lithuanian': '🇱🇹',
  'Latvian': '🇱🇻',
  'Estonian': '🇪🇪',
};

export type EmojiFlagMapType = keyof typeof EmojiFlagMap;